import { useEffect, useState } from 'react';

export const useBreakpoints = () => {
  const getBreakpoint = () => ({
    onDesktopZone: window.innerWidth > 1024,
    onTabletZone: window.innerWidth >= 768 && window.innerWidth <= 1024,
    onMobileZone: window.innerWidth < 768,
  });

  const [breakpoints, setBreakpoints] = useState(getBreakpoint);

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints(getBreakpoint());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return breakpoints;
};
